import {
  FluidColor,
  FluidIconConfig,
  FluidIconKey,
  FluidSize,
} from '@lmig/fluid-core';
import { h } from '@stencil/core';

export const InlineAlert = (props: {
  icon: FluidIconConfig;
  message: string;
  color: FluidColor;
  onClick?: Function;
}) => {
  const { icon, message, color, onClick } = props;
  return (
    <div onClick={() => onClick()}>
      <fluid-text color={color} small={true} disableGutters={true}>
        <fluid-icon style={{ marginRight: '0.5em' }} config={icon} />
        <span innerHTML={message}></span>
      </fluid-text>
    </div>
  );
};

export const InlineInfo = (props: {
  show: boolean;
  info: string;
  onClick?: Function;
}) => {
  const { show, info, onClick } = props;
  const icon: FluidIconConfig = {
    key: FluidIconKey.INFO,
    color: FluidColor.INFO,
    size: FluidSize.XX_SMALL,
    inline: true,
    interactive: false,
  };
  return (
    show && (
      <InlineAlert
        icon={icon}
        message={info}
        color={FluidColor.INFO}
        onClick={onClick}
      />
    )
  );
};

export const InlineError = (props: {
  show: boolean;
  error: string;
  onClick?: Function;
}) => {
  const { show, error, onClick } = props;
  const icon: FluidIconConfig = {
    key: FluidIconKey.ERROR,
    color: FluidColor.ERROR,
    size: FluidSize.XX_SMALL,
    inline: true,
    interactive: false,
    position: {
      top: 10,
    },
  };

  return (
    show && (
      <InlineAlert
        icon={icon}
        message={error}
        color={FluidColor.ERROR}
        onClick={onClick}
      />
    )
  );
};
